import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { LegacyDialog } from '../../../../../../legacy-components/LegacyDialog';
import { CompanyFormType } from '../SharedIndex';

import { useSxStyles } from './useStyles';

type Props = {
  open: boolean;
  onClose: () => void;
  companyForms: CompanyFormType[];
  empId: string;
};

export const FormsDialog = ({ open, onClose, companyForms, empId }: Props) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  return (
    <LegacyDialog
      open={open}
      onClose={() => {
        onClose();
      }}
      onSave={() => {
        onClose();
      }}
      showSave={false}
      icon={'fa fa-file-text-o'}
      showCancel={false}
      title={'laCompanyForms'}
    >
      <table>
        <thead>
          <tr>
            <Box component="th" sx={sxStyles.dialogTableHeader}>
              {t('laFormName')}
            </Box>
            <Box component="th" sx={sxStyles.dialogTableHeader}>
              {t('laDescription')}
            </Box>
            <Box component="th" sx={sxStyles.dialogTableHeader}>
              {t('laExpirationDate')}
            </Box>
            <Box component="th" sx={sxStyles.dialogTableHeader}>
              {t('laDownload')}
            </Box>
          </tr>
        </thead>
        <tbody>
          {companyForms.map((form) => {
            return (
              <tr key={form.fComFormAttachmentId}>
                <Box component="td" sx={sxStyles.dialogTableTdBold}>
                  {form.fComFormName}
                </Box>
                <Box component="td" sx={sxStyles.dialogTableTd}>
                  {form.fComFormDescription}
                </Box>
                <Box component="td" sx={sxStyles.dialogTableTd}>
                  {form.fComFormExpirationDate}
                </Box>
                <Box component="td" sx={sxStyles.dialogTableTd}>
                  {form.fComFormAttachmentName}
                </Box>
              </tr>
            );
          })}
        </tbody>
      </table>
    </LegacyDialog>
  );
};
